module.exports = "mutation DeleteBlogPost($id: ID!) {\n  deleteBlogPost(id: $id)\n}"